import React from 'react';
import PropTypes from 'prop-types';
import styles from './Integration.module.scss';
import Button from '../../common/Button';
import Box from '../../common/Box';
import _ from 'lodash';

function Integration(props) {
  const { onOpen } = props;
  const { ecommerce_products_integration, ecommerce_orders_integration } = props.retailer;

  let hasIntegration = false;
  let integrationType = '';

  if (ecommerce_products_integration && ecommerce_orders_integration) {
    if (ecommerce_products_integration.hasOwnProperty('type') && ecommerce_orders_integration.hasOwnProperty('type')) {
      hasIntegration = true;
      integrationType = ecommerce_products_integration.type;
    }
  }

  const isShopifyIntegration = integrationType === 'shopify';

  return (
    <Box>
      <div className={styles.body}>
        {hasIntegration ? (
          <>
            <div>
              <label>Integration type:</label>
              <span>{_.capitalize(integrationType)}</span>
            </div>

            <Button
              uppercase={false}
              text={isShopifyIntegration ? 'Setup Instructions' : 'Edit'}
              onClick={() => onOpen(integrationType)}
            />
          </>
        ) : (
          <>
            <Button uppercase={false} text="Add eCom Integration" onClick={onOpen} />
            <Button uppercase={false} text="Connect your Shopify Account" onClick={props.openShopifyModal} />

            {props.isAdmin && (
              <>
                <Button uppercase={false} text="Connect your Ebay Account" onClick={props.openEbayModal} />
                <Button uppercase={false} text="Connect your Google Shopping Account" onClick={props.openGoogleModal} />
              </>
            )}
          </>
        )}
      </div>
    </Box>
  );
}

export default Integration;

Integration.propTypes = {
  onOpen: PropTypes.func.isRequired,
  openShopifyModal: PropTypes.func.isRequired,
  openGoogleModal: PropTypes.func.isRequired,
  openEbayModal: PropTypes.func.isRequired,
  isAdmin: PropTypes.bool.isRequired,
};

Integration.defaultProps = {
  showAdmin: false,
};
